var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperOutIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "PaperOutIcon",
    d: "M8,6H18a2,2,0,0,1,2,2V18a2,2,0,0,1-2,2H6M8,6V18M8,6A2,2,0,0,0,4,6V18m2,2a2,2,0,0,1-2-2m2,2a2,2,0,0,0,2-2M4,18a2,2,0,0,1,4,0",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperOutIconDark);
export default __webpack_public_path__ + "static/media/PaperOutIconDark.8ea440050a66fab5594f78cd7cd08888.svg";
export { ForwardRef as ReactComponent };